import { render, staticRenderFns } from "./BadgeStyleLayerEditor.vue?vue&type=template&id=2269a223&scoped=true"
import script from "./BadgeStyleLayerEditor.vue?vue&type=script&lang=js"
export * from "./BadgeStyleLayerEditor.vue?vue&type=script&lang=js"
import style0 from "./BadgeStyleLayerEditor.vue?vue&type=style&index=0&id=2269a223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269a223",
  null
  
)

export default component.exports